import { emptyCSSTemplateFunc } from '@hzero-front-ui/core';
var spinStyle = emptyCSSTemplateFunc;
export default spinStyle;